import { Box, ButtonBase, Typography } from '@mui/material';
import NotificationIcon from '@/app/assets/icons/notification.svg?react';
import { UILoader } from './ui/ui-loader';

export const Notification = ({
  onClick,
  count = 0,
  isLoading = false,
}: {
  onClick: () => void;
  count?: number;
  isLoading: boolean;
}) => {
  const hasNotifications = count > 0;

  return (
    <Box
      component={ButtonBase}
      onClick={onClick}
      sx={{
        width: 40,
        height: 40,
        background: '#FFFFFF',
        borderRadius: '6px',
        position: 'relative',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
          height: '100%',
          opacity: hasNotifications ? 1 : 0.5,
        }}
      >
        {isLoading ? <UILoader size={20} /> : <NotificationIcon />}
      </Box>
      {hasNotifications && (
        <Box
          sx={{
            width: 16,
            height: 16,
            position: 'absolute',
            top: -2,
            right: -2,
            background: '#F34F4F',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Typography
            variant='body2'
            sx={{
              fontSize: 9,
              fontWeight: 600,
              color: '#FFFFFF',
            }}
          >
            {count}
          </Typography>
        </Box>
      )}
    </Box>
  );
};
